import React from 'react';

// Presentational: expects `insurance` to be passed as a prop by the parent
const InsuranceInfo = ({ insurance = null, formatDate = (d) => d }) => {
    // Normalize wrapper { success, data } and multiple possible key shapes
    let normalized = null;
    try {
        if (insurance && typeof insurance === 'object' && 'success' in insurance) {
            normalized = insurance.success ? insurance.data : null;
        } else {
            normalized = insurance;
        }
    } catch (e) {
        normalized = null;
    }

    const policyNo = normalized?.policy_number || normalized?.policy || normalized?.policyNo || normalized?.policy_no;
    const company = normalized?.insurance_company_name || normalized?.company || normalized?.provider || normalized?.insurer_name || normalized?.insurer;
    const insType = normalized?.insurance_type_name || normalized?.type || normalized?.category || normalized?.insurance_type;
    const expiry = normalized?.end_date || normalized?.expiry || normalized?.insurer_expiry || normalized?.expiry_date;
    const stickerUrl = normalized?.insurance_sticker_link || normalized?.sticker_url || normalized?.sticker || normalized?.sticker_link || normalized?.stickerUrl;

    return (
        <div className="bg-gray-50 rounded-sm border border-gray-200 p-3">
            <h3 className="text-xs font-bold text-[#2a2e30] mb-2.5 flex items-center">
                <div className="w-2 h-2 bg-[#FF5733] rounded-full mr-2"></div>
                Insurance Details
            </h3>
            <div className="space-y-2 text-xs">
                {insurance ? (
                    <div className="space-y-2 text-xs">
                        <div className="flex flex-col xl:flex-row xl:justify-between xl:items-center">
                            <span className="text-gray-700 font-medium">Policy:</span>
                            <span className="font-medium text-[#2a2e30] text-xs xl:min-w-0 xl:truncate xl:text-right" title={policyNo || ''}>{policyNo || '—'}</span>
                        </div>
                        <div className="flex flex-col xl:flex-row xl:justify-between xl:items-center">
                            <span className="text-gray-700 font-medium">Company:</span>
                            <span className="font-medium text-[#2a2e30] text-xs xl:min-w-0 xl:truncate xl:text-right" title={company || ''}>{company || '—'}</span>
                        </div>
                        <div className="flex flex-col xl:flex-row xl:justify-between xl:items-center">
                            <span className="text-gray-700 font-medium">Type:</span>
                            <span className="font-medium text-[#2a2e30] text-xs xl:min-w-0 xl:truncate xl:text-right" title={insType || ''}>{insType || '—'}</span>
                        </div>
                        <div className="flex flex-col xl:flex-row xl:justify-between xl:items-center">
                            <span className="text-gray-700 font-medium">Expiry:</span>
                            <span className={`font-medium text-xs ${
                                expiry ? (() => {
                                    const daysLeft = Math.ceil((new Date(expiry) - new Date()) / (1000 * 60 * 60 * 24));
                                    if (daysLeft < 0) return 'text-red-600 font-bold';
                                    if (daysLeft <= 30) return 'text-orange-500 font-bold';
                                    return 'text-[#2a2e30]';
                                })() : 'text-[#2a2e30]'
                            }`}>
                                {expiry ? formatDate(expiry) : '—'}
                            </span>
                        </div>
                        {stickerUrl ? (
                            <div className="flex flex-col xl:flex-row xl:justify-between xl:items-center">
                                <span className="text-gray-700 font-medium">Sticker:</span>
                                <a className="text-xs text-blue-600 hover:underline" href={stickerUrl} target="_blank" rel="noreferrer noopener">View sticker</a>
                            </div>
                        ) : null}
                    </div>
                ) : (
                    <div className="text-xs text-gray-500">No insurance record found</div>
                )}
            </div>
        </div>
    );
};

export default InsuranceInfo;
